import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import vSelect from 'vue-select'
import VueTheMask from 'vue-the-mask'

//import Maska from 'maska'
import myMixin from '@/helpers/mixins/helper' 

Vue.mixin(myMixin); 


//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-select/dist/vue-select.css'; 


// import the styles
import "../src/design/app.scss";


import store from '@/state/store'

import App from './App.vue'
import i18n from './i18n'

Vue.use(VueGoodTablePlugin);
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
Vue.use(VueTheMask)
Vue.use(require('vue-chartist'))
Vue.component('apexchart', VueApexCharts)

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
//Vue.use(Maska)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

Vue.prototype.$paraFormat = function (value, currency = 'TRY') {
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency }).format(value);
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

